import React, { useState } from "react";

import {
  ChevronRight as ChevronRightIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { Collapse, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()((theme) => ({
  listItem: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  listItemIcon: {
    color: colors.grey,
  },
  listItemText: {
    color: colors.dark,
  },
  listItemPrimary: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 1,
    letterSpacing: -0.5,
  },
  chevron: {
    color: colors.dark,
    minWidth: 0,
  },
  activeLink: {
    color: theme.palette.primary.main,
    "& .MuiListItemIcon-root": {
      color: "inherit",
    },
    "& .MuiListItemText-root": {
      color: "inherit",
    },
  },
}));

interface Props {
  icon?: React.ReactNode;
  text: string;
}

const ListItemSublist: React.FC<Props> = ({ icon, text, children }) => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  return (
    <li>
      <ListItem
        className={classes.listItem}
        button
        onClick={() => setOpen(!open)}
      >
        {Boolean(icon) && (
          <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
        )}
        <ListItemText
          className={classes.listItemText}
          classes={{ primary: classes.listItemPrimary }}
          primary={text}
        />
        <ListItemIcon className={classes.chevron}>
          {open ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </ListItemIcon>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </li>
  );
};

export default ListItemSublist;
